import { ConfigurationService } from './configuration.service';

export function configurationInitializerFactory(
  configurationService: ConfigurationService,
): () => Promise<void> {
  return async () => configurationService.initialize();
}
